// PR-15 (i18n): apply the effective locale by driving i18next.
//
// Resolution chain (memory N1): per-thread override → user preference →
// browser detection. Browser detection is i18next's own init default, so
// this hook only has to apply the two explicit tiers on top; when neither
// is set it leaves the detected language untouched.

import { useEffect } from 'react'
import i18n, { asLocale } from './index'

/**
 * Keep i18next's active language in sync with the locale chain. Pass the
 * user-wide preference (`MeResponse.locale`) and the active thread's
 * override (`threads.locale`); either may be null/undefined to fall
 * through. Call once near the app root with the live values.
 */
export function useLocaleSync(
  userLocale: string | null | undefined,
  threadLocale: string | null | undefined,
): void {
  const effective = asLocale(threadLocale) ?? asLocale(userLocale)
  useEffect(() => {
    if (effective && i18n.language !== effective) {
      void i18n.changeLanguage(effective)
    }
  }, [effective])
}
